import {graphql} from 'react-relay'

export const query = graphql`
  query SharedSettingsSshKeysPageQuery($projectId: ProjectId!) {
    getProjectSshKeys(projectId: $projectId) {
      ...SharedSettingsSshKeysTableFragment
    }
  }
`
